import { Navigate, Route, Routes } from "react-router-dom";
import { PageTitle } from "../../../_start/layout/core";
import { CreateVoipGrid } from "./pages/CreateVoipGrid";
import { QuotationsPage } from "./pages/QuotationsPage";
import { SendQuote } from "./pages/SendQuote";
import { UpdateQuotation } from "./pages/UpdateQuotation";
import { ViewQuote } from "./pages/ViewQuote";

export const QuotationManagementPage = () => {
  return (
    <Routes>
      <Route
        path="quotations"
        element={
          <>
            <PageTitle>Quotations</PageTitle>
            <QuotationsPage />
          </>
        }
      />

      <Route
        path="quotations/send-quote"
        element={
          <>
            <PageTitle>Quotations</PageTitle>
            <SendQuote />
          </>
        }
      />

      <Route
        path="quotations/:id/update"
        element={
          <>
            <PageTitle>Quotations</PageTitle>
            <UpdateQuotation />
          </>
        }
      />

      <Route
        path="quotations/:id/voipgrid"
        element={
          <>
            <PageTitle>Quotations</PageTitle>
            <CreateVoipGrid />
          </>
        }
      />

      <Route
        path="quotations/:id/bekijk-offerte"
        element={
          <>
            <PageTitle>Quotations</PageTitle>
            <ViewQuote></ViewQuote>
          </>
        }
      />

      <Route
        index
        element={<Navigate to="/quotation-management/quotations" replace />}
      />
      <Route
        path="*"
        element={<Navigate to="/quotation-management/quotations" replace />}
      />
    </Routes>
  );
};
